<div class="form-group row">
	<div class="col-9 col-md-4">
		<app-gen-autocomplete
			#meetingtypeAc
			title_ph_lang="meetingtype"
			onClickClearAndShowOpts
			tabindex="-1"
			[fuzzySearchableClasses]="['meetingtypes']"
			(chosenEvent)="changeMeetingtype()"
			[actualObj]="actualObj"
			[error]="$safeNavigationMigration(errors?.meetingtype_id)"
			fieldName="meetingtype_id"
		/>
	</div>
</div>
<div class="form-group row">
	<div class="col-12 col-md-11">
		<app-gen-button-group
			isArray
			title_ph_lang="repeat"
			[actualObj]="actualObj"
			fieldName="series_repeat"
			[options]="repeatOptions"
			(changeEvent)="periodGo()"
		/>
	</div>
</div>
<div class="form-group row">
	<div class="col-3 col-lg-4">
		<app-gen-input
			[actualObj]="actualObj"
			[errors]="errors"
			fieldName="length"
			tabindex="-1"
			(changeEvent)="periodGo()"
			[addonObject]="{ after: { text: ('min' | langVal) } }"
		/>
	</div>
</div>
@if (hasLocations) {
	<div class="form-group row">
		<div class="col-12 col-md-11">
			<app-autocomplete-with-tags
				(chosenEvent)="chooseTagsForLocations($event)"
				title_ph_lang="filter_locations"
			/>
		</div>
	</div>
}
@if (hasAssocSelect) {
	<div class="form-group row">
		<div class="col-12 col-md-11">
			<app-autocomplete-multi
				siteDataTable="sub_users"
				(chosenEvent)="chooseAssoc($event)"
				title_ph_lang="sub_user"
				[excludeIds]="excludeIds"
				[noInput]="actualObj.assoc_sub_user_id"
				[siteDataFilters]="{ active: 'yes' }"
			/>
			@if (errors?.assoc_sub_user_id) {
				<p class="error">{{ errors.assoc_sub_user_id }}</p>
			}
		</div>
	</div>
}

@if (isFormSubmittable) {
	<div>
		<app-spin-or-content [isSpin]="isCalculating">
			<div class="row">
				<div class="col-12 dates-row">
					<button
						class="cal-btn cal-icon"
						(click)="periodGo(-1)"
						icon="rightArrow"
					></button>
					<div class="dates-title">{{ startDate | dateFormat }}</div>
					<!--- {{endDate | dateFormat}} -->
					<button
						class="cal-btn cal-icon"
						(click)="periodGo(1)"
						icon="leftArrow"
					></button>

					<!-- <button class="cal-btn" (click)="periodGo(-1)">&lt;</button>
          <button class="cal-btn" (click)="periodGo(1)">&gt;</button>-->
				</div>
			</div>
			<div class="row meeting-times">
				<div class="col-12 col-md-4 no-mob">
					<app-date-picker
						noInput
						(changeEvent)="chDate($event)"
					/>
				</div>

				<div class="col-12 col-md-8 hours-space">
					<table>
						<tbody>
							@for (availableDate of availableDates; track availableDate) {
								@if (newWeeksDates[availableDate]) {
									<tr class="spacer">
										<td colspan="99999"></td>
									</tr>
								}

								<tr class="date-row">
									<td valign="top">
										<h6>{{ datesToDays[availableDate] | langVal }}</h6>
									</td>
									<td valign="top">
										{{ availableDate | dateFormat }}
									</td>
									<td>
										<div class="chunks">
											@for (
												chunk of availableTimeChunksDates[availableDate];
												track chunk
											) {
												<div (click)="openMeetingModal(availableDate, chunk)">
													<!-- class="mt-hours" -->
													<div>
														{{ chunk.start | timeFormat }}-{{
															chunk.end | timeFormat
														}}
													</div>
													@if (chunk?.location) {
														<div>
															{{ chunk?.location }}
														</div>
													}
												</div>
											}
										</div>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</app-spin-or-content>
	</div>
}
